;$(function() {

	$('.nearest-dealers__toggler').click(() => {

		if ($('.nearest-dealers__content').css('display') == 'none')
			$('.nearest-dealers__content').slideDown();
		else
			$('.nearest-dealers__content').slideUp();

	});

});